<template>
  <!-- Both gas tables start -->
  <div class="table-div">
    <!-- gas table 1 start -->
    <b-table
      class="table-div table-scroll tbl-sml"
      v-if="converter"
      striped
      text-center
      :items="filteredReadings"
      :fields="summaryConverterFields"
      :per-page="3"
      @row-clicked="toggleObject"
    >
      <template slot="ReadingDate" slot-scope="data">{{
        data.item.ReadingDate | shortDate
      }}</template>
      <template slot="MeterReading" slot-scope="data">{{
        data.item.ConverterCorrectedReading != null
          ? data.item.ConverterCorrectedReading.toString().padStart(
              data.item.Dials || meterBySerial(data.item.Serial).Dials,
              "0"
            )
          : data.item.MeterReading.toString().padStart(
              data.item.Dials || meterBySerial(data.item.Serial).Dials,
              "0"
            )
      }}</template>
      <template slot="ConverterUncorrectedReading" slot-scope="data">{{
        data.item.ConverterUncorrectedReading.toString().padStart(
          data.item.Dials || meterBySerial(data.item.Serial).Dials,
          "0"
        )
      }}</template>
      <template slot="ReadingType" slot-scope="data">
        <p v-if="data.item.ReadingType === 'Customer'">C</p>
        <p v-else-if="data.item.ReadingType === 'ActualFromIndustry'">A</p>
        <p v-else-if="data.item.ReadingType.includes('Estimate')">E</p>
        <p class="d-inline" v-else-if="data.item.ReadingType === 'Deemed'">D</p>
      </template>
      <template slot="HEAD_ReadingType">
        <th class="d-inline">Reading Type</th>
        <div class="d-inline">
          <span class="d-inline">
            <span
              v-b-popover.hover.right.html="
                '<div><b>A</b> - Actual Reading</div><br><div><b>C</b> - Customer Reading</div><br><div><b>E</b> - Estimated Reading</div><br><div><b>D</b> - Deemed Reading</div>'
              "
              title="Reading Type"
              class="pointer"
            >
              <i class="fa fa-question-circle" aria-hidden="true"></i>
            </span>
          </span>
        </div>
      </template>
      <template slot="ConverterCorrectedReading" slot-scope="data">{{
        data.item.ConverterCorrectedReading.toString().padStart(
          data.item.Dials || meterBySerial(data.item.Serial).Dials,
          "0"
        )
      }}</template>
      <template slot="AssociatedInvoices" slot-scope="data">
        <div
          v-if="
            data.item.AssociatedInvoices &&
            data.item.AssociatedInvoices.length > 0
          "
        >
          <div
            v-for="(invoice, index) in data.item.AssociatedInvoices"
            :key="index"
          >
            <div v-if="billingInfo(invoice).length !== 0">
              Statement:
              {{ billingInfo(invoice)[0].StatementNumber }}
            </div>
          </div>
        </div>
        <div v-else @click="isBillable($event, data.item)">
          <switches
            :value="!data.item.DoNotBill"
            type-bold="true"
            theme="bootstrap"
            color="success"
            text-enabled="Included"
            text-disabled="Excluded"
          ></switches>
        </div>
      </template>
    </b-table>
    <!-- gas table 1 end -->
    <!-- gas table 2 start -->
    <b-table
      class="table-scroll tbl-sml"
      v-else
      striped
      text-center
      :items="filteredReadings"
      :fields="summaryFields"
      :per-page="3"
      @row-clicked="toggleObject"
    >
      <template slot="ReadingDate" slot-scope="data">{{
        data.item.ReadingDate | shortDate
      }}</template>
      <template slot="MeterReading" slot-scope="data">
        {{
          data.item.ConverterCorrectedReading != null
            ? data.item.ConverterCorrectedReading.toString().padStart(
                data.item.Dials || meterBySerial(data.item.Serial).Dials,
                "0"
              )
            : data.item.MeterReading.toString().padStart(
                data.item.Dials || meterBySerial(data.item.Serial).Dials,
                "0"
              )
        }}
        <!-- {{data.item.MeterReading.toString().padStart(this.activeMeterInfo.Dials, '0')}} -->
      </template>
      <template slot="ReadingType" slot-scope="data">
        <p v-if="data.item.ReadingType === 'Customer'">C</p>
        <p v-else-if="data.item.ReadingType === 'ActualFromIndustry'">A</p>
        <p v-else-if="data.item.ReadingType.includes('Estimate')">E</p>
        <!-- <p v-else-if="data.item.ReadingType === 0">E</p> -->
        <p class="d-inline" v-else-if="data.item.ReadingType === 'Deemed'">D</p>
      </template>
      <template slot="HEAD_ReadingType">
        <th class="d-inline">Reading Type</th>
        <div class="d-inline">
          <span class="d-inline">
            <span
              v-b-popover.hover.right.html="
                '<div><b>A</b> - Actual Reading</div><br><div><b>C</b> - Customer Reading</div><br><div><b>E</b> - Estimated Reading</div><br><div><b>D</b> - Deemed Reading</div>'
              "
              title="Reading Type"
              class="pointer"
            >
              <i class="fa fa-question-circle" aria-hidden="true"></i>
            </span>
          </span>
        </div>
      </template>
      <template slot="AssociatedInvoices" slot-scope="data">
        <div
          v-if="
            data.item.AssociatedInvoices &&
            data.item.AssociatedInvoices.length > 0
          "
          class="d-flex justify-content-center"
        >
          <div
            v-for="(invoice, index) in data.item.AssociatedInvoices"
            :key="index"
            class="badge-billing-info"
          >
            <div v-if="billingInfo(invoice).length !== 0">
              {{ billingInfo(invoice)[0].StatementNumber }}
            </div>
          </div>
        </div>
        <div v-else @click="isBillable($event, data.item)">
          <switches
            :value="!data.item.DoNotBill"
            type-bold="true"
            theme="bootstrap"
            color="success"
            text-enabled="Included"
            text-disabled="Excluded"
          ></switches>
        </div>
      </template>
    </b-table>
    <!-- gas table 2 end -->
  </div>
  <!-- Both gas tables end -->
</template>

<script>
import gasReadingsMixin from "@/mixins/meterInfo/readings/gasReadings.js";
import _filters from "@/mixins/filters";

export default {
  name: "gas-readings",
  mixins: [gasReadingsMixin, _filters],
  computed: {
    // Override to always apply filtering regardless of showExcludedReadings
    filteredReadings() {
      let readings = this.readings;

      // Always apply the excluded readings filter
      readings = this.filterByExcludedReadings(readings);

      readings =
        this.meterSerialFilter === 'All'
          ? readings
          : this.filterByMeterSerial(readings);
      readings = this.showOnlyCustomer
        ? this.filterByCustomer(readings)
        : readings;

      return readings;
    }
  }
};
</script>

<style scoped>
.badge-billing-info {
  border: 1px solid #28a745;
  color: #28a745;
  margin: 0.5em;
  min-width: 2em;
  border-radius: 0.2em;
}
</style>